<template>
  <v-container>
    <v-card
      class="pa-6"
      color="background"
      tile
      flat
    >
      <v-row>
        <v-col cols="12" md="6" v-for="item in items" :key="item.title">
          <v-card :to="item.path" class="pa-4" flat>
            <v-row justify="space-between" align="center">
              <v-col cols="2">
                <v-avatar :color="item.color" :size="$vuetify.breakpoint.lgAndUp ? 64 : 42">
                  <v-icon dark>
                    {{ item.icon }}
                  </v-icon>
                </v-avatar>
              </v-col>
              <v-col cols="8">
                <div :class="$vuetify.breakpoint.lgAndUp ? 'text-h6' : 'body-1'">
                  {{ item.title }}
                </div>
              </v-col>
              <v-col cols="2">
                <v-icon>
                  mdi-chevron-right
                </v-icon>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      items: [
        {
          title: "Product Finder",
          icon: "mdi-auto-fix",
          path: "/pipeline/product-finder",
          color: "error",
        },
        {
          title: "Loan Registration",
          icon: "mdi-open-in-new",
          path: "/pipeline/loan-registration",
          color: "secondary",
        },
        {
          title: "Pipeline",
          icon: "mdi-database-search-outline",
          path: "/pipeline",
          color: "success",
        },
        {
          title: "Forms",
          icon: "mdi-chart-line",
          path: "/pipeline/resources",
          color: "warning",
        },
        {
          title: "Matrix",
          icon: "mdi-pencil-box-outline ",
          path: "/pipeline/resources",
          color: "error",
        },
        {
          title: "Appraisal Fee Finder",
          icon: "mdi-currency-usd",
          path: "/pipeline/appraisal-fee-finder",
          color: "secondary",
        },
      ],
    };
  },
};
</script>
